export const APP_LONG_NAME = 'Netflix Clone'
export const APP_SHORT_NAME = 'Netflix Clone'
export const APP_INITIALS = 'NC'